import { t } from "@/i18n-js/instance";
import { BlockInViewOnlyMode } from "@circle-react/components/ViewOnlyMasquerading/BlockInViewOnlyMode";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { BannerContent } from "./BannerContent";
import { DisplayMedia } from "./DisplayMedia";

export interface WelcomeBannerContentProps {
  allowClose: boolean;
  closeClick: () => void;
  description?: string;
  editBannerClick: () => void;
  isAdmin: boolean;
  isLoading: boolean;
  isVideo: boolean;
  mediaUrl?: string;
  title: string;
}

export const WelcomeBannerContent = ({
  allowClose,
  closeClick,
  description,
  editBannerClick,
  isAdmin,
  isLoading,
  isVideo,
  mediaUrl,
  title,
}: WelcomeBannerContentProps) => {
  if (isLoading || (!mediaUrl && !title && !description)) {
    return null;
  }

  return (
    <div className="welcome-banner !my-6 md:!mt-0">
      <div
        className="welcome-banner__inside !shadow-none"
        data-testid="welcome-banner-inside"
      >
        {isAdmin ? (
          <span className="welcome-banner__more z-10">
            <BlockInViewOnlyMode>
              <Dropdown
                buttonClassName="welcome_banner_dropdown"
                direction="bottom-end"
                menuButtonEl="div"
                button={
                  <Dropdown.MenuButton className="!py-0">
                    <IconButton
                      name="20-menu-dots-horizontal"
                      iconClassName="!text-default group-hover:!text-dark !w-5 !h-5"
                      className={classNames("group", {
                        "bg-tertiary": mediaUrl,
                      })}
                      variant="secondary"
                      iconSize={20}
                      buttonSize={28}
                      data-testid="welcome_banner_button"
                      ariaLabel={t("home_page.welcome_banner_actions")}
                    />
                  </Dropdown.MenuButton>
                }
              >
                <Dropdown.ItemLink onClick={editBannerClick}>
                  <div>{t("home_page.edit_banner")}</div>
                </Dropdown.ItemLink>
                <Dropdown.ItemLink hasDanger onClick={closeClick}>
                  <div>{t("home_page.hide_banner")}</div>
                </Dropdown.ItemLink>
              </Dropdown>
            </BlockInViewOnlyMode>
          </span>
        ) : (
          <>
            {allowClose && (
              <button
                type="button"
                className="welcome-banner__close"
                onClick={closeClick}
              >
                <Icon type="close" className="mb-1" />
              </button>
            )}
          </>
        )}
        {mediaUrl && (
          <div className="welcome-banner__feature">
            <DisplayMedia
              mediaURL={mediaUrl}
              isVideo={isVideo}
              hasContent={Boolean(title || description)}
            />
          </div>
        )}
        {(title || description) && (
          <BannerContent
            title={title}
            description={description}
            hasMedia={Boolean(mediaUrl)}
          />
        )}
      </div>
    </div>
  );
};
